// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"127":"eebff6f7","315":"2c0fc437","624":"4f62e898"}[chunkId] + ".js";
};